import axios from "axios";
import _ from "lodash";
import { serverApi } from "../config/Keys";

const baseConfigV1 = {
  baseURL: `${serverApi}`,
  timeout: 150000,
};

const baseConfigPub = {
  baseURL: `${serverApi}`,
  timeout: 150000,
};

const baseConfigAdmin = {
  baseURL: `${serverApi}/api/admin/`,
  timeout: 150000,
};

const amealioApiInstance = axios.create({ ...baseConfigPub });
const amealioApiAuthInstance = axios.create({ ...baseConfigV1 });
const amealioApiAdminInstance = axios.create({ ...baseConfigAdmin });

const defaultErrorInterceptor = (error) => {
  console.log("Error while performing request");
  console.error(error);
  return Promise.reject(error);
};

amealioApiAuthInstance.interceptors.request.use((request) => {
  return request;
});

amealioApiAuthInstance.interceptors.response.use((response) => {
  return response;
});

amealioApiInstance.interceptors.response.use(null, defaultErrorInterceptor);
amealioApiAuthInstance.interceptors.response.use(null, defaultErrorInterceptor);
amealioApiAdminInstance.interceptors.response.use(
  null,
  defaultErrorInterceptor
);

function setAuthenticationToken(token) {
  const headersV1 = _.cloneDeep(amealioApiAuthInstance.defaults.headers);
  const headersA1 = _.cloneDeep(amealioApiAdminInstance.defaults.headers);

  if (!token) {
    delete headersV1.common["authorization"];
    delete headersA1.common["authorization"];
  } else {
    headersV1.common["authorization"] = `${token}`;

    headersA1.common["authorization"] = `${token}`;
  }
  amealioApiAuthInstance.defaults.headers = headersV1;
  amealioApiAdminInstance.defaults.headers = headersA1;
}

const headersP1 = _.cloneDeep(amealioApiInstance.defaults.headers);
amealioApiInstance.defaults.headers = headersP1;

export {
  amealioApiInstance as amPubApi,
  amealioApiAuthInstance as amApi,
  amealioApiAdminInstance as amAdminApi,
  setAuthenticationToken,
};
